import { Controller } from "@hotwired/stimulus";

export default class SidebarToggleController extends Controller {
  trigger(): void {
    this.dispatch("toggle");
  }
}
